module.exports = __webpack_public_path__ + "static/img/kc06.4c6e519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kc06.png
// module id = azCM
// module chunks = 1